package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import one.healthium.bundle.components.BundleImage
import one.healthium.onboarding.domain.configs.CongratsV3ScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface CongratsV3EventDelegate {
    fun onNextClicked()
}

@Composable
internal fun CongratsV3Screen(
    eventDelegate: CongratsV3EventDelegate,
    screenConfig: CongratsV3ScreenConfig,
) {
    UserDataProvider { userState, _ ->
        CongratsScreenContent(
            screenConfig = screenConfig,
            userState = userState,
            onNextClicked = eventDelegate::onNextClicked,
        )
    }
}

@Composable
private fun CongratsScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: CongratsV3ScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(horizontal = 24.dp)
            .statusBarsPadding()
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppText(
            modifier = Modifier.padding(horizontal = 12.dp),
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = screenConfig.titleStyle.toTextStyle(AppTheme.textStyles.header),
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(24.dp))
        AppText(
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.weight(0.3f))
        BundleImage(
            modifier = Modifier.fillMaxWidth(),
            name = screenConfig.image?.value(userState.gender),
            contentScale = ContentScale.Fit,
        )
        AppText(
            modifier = Modifier.padding(top = 16.dp),
            text = screenConfig.imageCaption?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.caption.copy(lineHeight = 24.sp),
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.weight(1f))
        Spacer(Modifier.height(16.dp))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp),
            onClick = onNextClicked,
            text = screenConfig.ctaTitle,
        )
        Spacer(Modifier.height(24.dp))
    }
}
